module.exports = "<router-outlet>\n    <app-spinner>\n        <app-title></app-title>\n    </app-spinner>\n</router-outlet>"